import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

import { Api } from '@shared/constants/api';

/**
 * Registered app-wide as the single RouteReuseStrategy, so it governs every route transition,
 * not just chat. It only special-cases the /chat -> /chat/:sessionId transition, to keep the
 * chat component (and its in-flight poll) alive across that navigation; everything else falls
 * back to the default strategy.
 */
@Injectable()
export class ReportingAgentChatRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (
      curr.routeConfig?.path === Api.chat &&
      future.routeConfig?.path === `${Api.chat}/:${Api.sessionId}` &&
      future.component === curr.component
    ) {
      return true;
    }

    return super.shouldReuseRoute(future, curr);
  }
}
